/*
 * formikReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Bartolo Amico
 * @since 23-Sep-2022
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/formik'

const ACTION_HANDLERS = {
  [actionTypes.DO_SAVE_FORM]: produce((draft, action) => {
    draft.formikForm.name = action.payload.name
    draft.formikForm.data = Object.assign({}, draft.formikForm.data, action.payload.data)
  }),
  [actionTypes.DO_SHOW_ERROR]: produce((draft) => {
    draft.error = true
  }),
  [actionTypes.DO_HIDE_ERROR]: produce((draft) => {
    draft.error = false
  })
  // @generator reducer:type:action
}

// The initial state of the formik
const initialState = {
  formikForm: { name: '', data: {} },
  error: false
}

const formik = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default formik
